import { z } from 'zod';

export const agentTodoListSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentTodoListSettings = z.infer<typeof agentTodoListSettings>;

export const agentFileSystemSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentFileSystemSettings = z.infer<typeof agentFileSystemSettings>;

export const agentMemorySettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentMemorySettings = z.infer<typeof agentMemorySettings>;

export const agentCitationsSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentCitationsSettings = z.infer<typeof agentCitationsSettings>;

const classificationConstraintHintSchema = z.object({
  field: z.string().optional(),
  op: z.enum(['=', '>', '<', '>=', '<=']).optional(),
  value: z.unknown().optional(),
});

const classificationEntityHintSchema = z.object({
  type: z.string(),
  value: z.string().optional(),
});

export const agentClassificationHintsSchema = z.object({
  topics: z.array(z.string()).optional(),
  entities: z.array(classificationEntityHintSchema).optional(),
  constraints: z.array(classificationConstraintHintSchema).optional(),
});
export type AgentClassificationHints = z.infer<typeof agentClassificationHintsSchema>;

export const agentClassificationSettings = z.object({
  enabled: z.boolean().default(false),
  hints: agentClassificationHintsSchema.optional(),
  prefixBadges: z.boolean().default(false),
});
export type AgentClassificationSettings = z.infer<typeof agentClassificationSettings>;

export const agentEvaluationSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentEvaluationSettings = z.infer<typeof agentEvaluationSettings>;

export const agentResearchArtifactSettings = z.object({
  enabled: z.boolean().default(false),
});
export type AgentResearchArtifactSettings = z.infer<typeof agentResearchArtifactSettings>;

export const queryRewriteSettings = z.object({
  enabled: z.boolean().default(false),
});
export type QueryRewriteSettings = z.infer<typeof queryRewriteSettings>;

export const smartRoutingSettings = z.object({
  searchIndex: z.string().optional(),
  connectionIdentifier: z.string().optional(),
});
export type SmartRoutingSettings = z.infer<typeof smartRoutingSettings>;

export const formWorkflowAgentSettings = z.object({
  workflows: z.array(
    z.object({
      key: z.string(),
    })
  ),
});
export type FormWorkflowAgentSettings = z.infer<typeof formWorkflowAgentSettings>;
